export default __webpack_public_path__ + "static/media/document-icon.8d407ced.svg";